import ModalCancelationPolicy from './ModalCancelationPolicy';
export default ModalCancelationPolicy;
